import React from 'react';
import ReactDOM from 'react-dom'
import './index.css';
import App from './components/App'
import SubscriptionApp from './components/SubscriptionApp'
import RedemptionApp from './components/RedemptionApp'
import * as serviceWorker from './serviceWorker'
import VariantApp from './components/VariantApp'
import FulfillmentApp from './components/FulfillmentApp'
import IntegrateApp from './components/IntegrateApp'
import InstoreApp from './components/InstoreApp'
import ManageMyFulfillmentsApp from './components/ManageMyFulfillments';
import ReportsApp from './components/ReportsApp';
import BrandApp from './components/BrandApp';
import client from './wf/client';
import DesignEditorApp from './components/DesignEditorApp'
import ExperienceApp from './components/ExperienceApp'  
import MembershipTiersApp from './components/MembershipTiersApp'
import MovementJoinApp from './components/MovementJoinApp'

const loadOnboardingStandaloneModal = () => {
  let el = document.getElementById("root-onboarding-standalone")
  let currentId = el?.dataset?.id
  if (el) {
    ReactDOM.render(
      <React.StrictMode>
        <App id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadBrandApp = () =>{
  let el = document.getElementById("root-brand")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <BrandApp id={currentId} fromPreOnboarding={false} standalone={true}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadBrandModal = () => {
  let el = document.getElementById("root-brand-modal")
  let fromPreOnboarding = el?.dataset?.fromPreOnboarding == "true" ? true : false
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <BrandApp id={currentId} fromPreOnboarding={fromPreOnboarding}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadDesignEditor = () => {
  let el = document.getElementById("root-design-editor")
  let alias = el?.dataset?.alias
  let value = el?.dataset?.value
  let inputSelector = el?.dataset?.inputSelector
  if (el && alias) {
    if (!value && inputSelector) {
      try {
        const inputEl = document.querySelector(inputSelector)
        if (inputEl && 'value' in inputEl) {
          value = inputEl.value
        }
      } catch (e) {
        // ignore selector errors
      }
    }
    console.log('value', value)
    console.log('inputSelector', inputSelector)
    ReactDOM.render(
      <React.StrictMode>
        <DesignEditorApp alias={alias} value={value} inputSelector={inputSelector}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadExperienceApp = () => {
  let el = document.getElementById("root-experience")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <ExperienceApp id={currentId}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadMovementJoin = () => {
  const el = document.getElementById('root-movement-join')
  const currentId = el?.dataset?.id
  // const currentId = 26695622
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <MovementJoinApp id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadOnboardingModal = () => {
  let el = document.getElementById("root-onboarding-modal")
  let currentId = el?.dataset?.id
  let apiKey = el?.dataset?.apiKey
  let host = el?.dataset?.host
  let routeBasename = el?.dataset?.routeBasename
  if (el && currentId) {
    try {
      const { pathname, search, hash } = window.location;
      const colonIndex = pathname.indexOf(':');
      if (colonIndex !== -1) {
        const normalizedPath = pathname.slice(0, colonIndex) || '/';
        if (normalizedPath !== pathname) {
          window.history.replaceState(null, '', normalizedPath + search + hash);
        }
      }
    } catch (e) {
      // ignore
    }
    ReactDOM.render(
      <React.StrictMode>
        <App id={currentId} apiKey={apiKey} host={host} routeBasename={routeBasename}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadOnboardingDashboard = () => {
  let el = document.getElementById("root-onboarding-dashboard")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <IntegrateApp id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadIntegrateScreen = () => {
  let el = document.getElementById("root-integrate-screen")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <IntegrateApp id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadInstoreGuide = () => {
  let el = document.getElementById("root-instore-guide")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <InstoreApp id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}
const loadUserMembershipFulfillments = () => {
  let el = document.getElementById("root-user-membership-fulfillments")
  let currentId = el?.dataset?.id
  const businessId = el?.dataset?.businessId
  const newMembershipId = el?.dataset?.newMembershipId
  if (el && currentId) {
    const cacheId = "User:" + currentId
    client.cache.evict({id: cacheId})
    client.cache.gc()
    ReactDOM.render(
      <React.StrictMode>
        <ManageMyFulfillmentsApp id={currentId} businessId={businessId} newMembershipId={newMembershipId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadSelectVariant = () => {
  const el = document.getElementById("root-update-variant")
  const subscriptionBenefitFulfillmentIds = el?.dataset?.subscriptionBenefitFulfillmentIds ? JSON.parse(el.dataset.subscriptionBenefitFulfillmentIds) : []
  const welcomeGiftFulfillmentId = el?.dataset?.welcomeGiftFulfillmentId
  const isAfterPurchase = !!el?.dataset?.isAfterPurchase || false
  if (el && (subscriptionBenefitFulfillmentIds.length > 0 || welcomeGiftFulfillmentId)) {
    ReactDOM.render(
      <React.StrictMode>
        <VariantApp subscriptionBenefitFulfillmentIds={subscriptionBenefitFulfillmentIds} welcomeGiftFulfillmentId={welcomeGiftFulfillmentId} isAfterPurchase={isAfterPurchase}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadSubscriptionBenefit = () => {
  let el = document.getElementById("root-subscription")
  let currentId = el?.dataset?.id
  let currentBusinessId = el?.dataset?.businessId
  let welcomeGiftMembershipId = el?.dataset?.welcomeGiftMembershipId
  let driveGiftId = el?.dataset?.driveGiftId
  let currentShopifyVersion = el?.dataset?.shopifyVersion ? Number(el.dataset.shopifyVersion) : null
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <SubscriptionApp businessId={currentBusinessId} id={currentId} shopifyVersion={currentShopifyVersion} welcomeGiftMembershipId={welcomeGiftMembershipId} driveGiftId={driveGiftId}/>
      </React.StrictMode>,
      el
    )
  }
}

const loadRedemptionBenefit = () => {
  let el = document.getElementById("root-redemption")
  let currentId = el?.dataset?.id
  let currentBusinessId = el?.dataset?.businessId
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <RedemptionApp businessId={currentBusinessId} id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

const loadMembershipTiers = () => {
  let el = document.getElementById("root-membership-tiers")
  let currentId = el?.dataset?.id
  let routeBasename = el?.dataset?.routeBasename
  if (el && currentId) {
    try {
      const { pathname, search, hash } = window.location;
      const colonIndex = pathname.indexOf(':');
      if (colonIndex !== -1) {
        const normalizedPath = pathname.slice(0, colonIndex) || '/';
        if (normalizedPath !== pathname) {
          window.history.replaceState(null, '', normalizedPath + search + hash);
        }
      }
    } catch (e) {
      // ignore
    }
    ReactDOM.render(
      <React.StrictMode>
        <MembershipTiersApp id={currentId} routeBasename={routeBasename} />
      </React.StrictMode>,
      el
    )
  }
}

const loadFulfillmentApp = () => {
  let el = document.getElementById("root-fulfillment")
  let currentId = el?.dataset?.id
  let currentFromLink = el?.dataset?.fromLink == "true" ? true : false
  let currentShopifyVersion = el?.dataset?.shopifyVersion ? Number(el.dataset.shopifyVersion) : null
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <FulfillmentApp id={currentId} fromLink={currentFromLink} shopifyVersion={currentShopifyVersion} />
      </React.StrictMode>,
      el
    )
  }
}

const loadReportsApp = () => {
  let el = document.getElementById("root-reports")
  let currentId = el?.dataset?.id
  if (el && currentId) {
    ReactDOM.render(
      <React.StrictMode>
        <ReportsApp id={currentId} />
      </React.StrictMode>,
      el
    )
  }
}

window.loadReactComponents = function () {
  loadOnboardingStandaloneModal()
  loadOnboardingDashboard()
  loadOnboardingModal()
  loadIntegrateScreen()
  loadSelectVariant()
  loadSubscriptionBenefit()
  loadRedemptionBenefit()
  loadMembershipTiers()
  loadFulfillmentApp()
  loadUserMembershipFulfillments()
  loadReportsApp()
  loadInstoreGuide()
  loadBrandModal()
  loadBrandApp()
  loadExperienceApp()
  loadDesignEditor()
  loadMovementJoin()
}

window.loadReactComponents()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
